import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // 模拟表单提交
    setTimeout(() => {
      alert("Thank you for your message! We will get back to you soon.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="contact">
      <Header />

      <main className="contact__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <span className="breadcrumb__current">CONTACT</span>
          </div>
        </div>

        <div className="contact__container">
          <div className="contact__content">
            {/* 页面标题 */}
            <section className="contact__hero">
              <h1 className="contact__title">CONTACT Emeline PUBLICATIONS</h1>
              <p className="contact__subtitle">
                Get in touch with our automotive experts
              </p>
            </section>

            <div className="contact__layout">
              {/* 联系信息 */}
              <div className="contact__info-section">
                <h2 className="section__title">Get In Touch</h2>

                <div className="contact__info-grid">
                  <div className="contact__info-item">
                    <div className="info__icon">
                      <i className="fas fa-clock"></i>
                    </div>
                    <div className="info__content">
                      <h3 className="info__title">Business Hours</h3>
                      <p className="info__text">
                        Monday - Friday: 9:30am to 4:00pm
                      </p>
                      <p className="info__text">
                        Saturday, Sunday & Public Holidays: Closed
                      </p>
                    </div>
                  </div>

                  <div className="contact__info-item">
                    <div className="info__icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div className="info__content">
                      <h3 className="info__title">Our Location</h3>
                      <p className="info__text">
                        Emeline Publications Australia
                      </p>
                      <p className="info__text">c/- Renniks Group Pty Ltd</p>
                      <p className="info__text">Unit 6, 30 Perry Street</p>
                      <p className="info__text">Matraville NSW 2036</p>
                    </div>
                  </div>

                  <div className="contact__info-item">
                    <div className="info__icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="info__content">
                      <h3 className="info__title">Email Support</h3>
                      <p className="info__text">
                        For general inquiries and technical support
                      </p>
                      <p className="info__text">
                        Response time: Within 24 hours
                      </p>
                    </div>
                  </div>

                  <div className="contact__info-item">
                    <div className="info__icon">
                      <i className="fas fa-shipping-fast"></i>
                    </div>
                    <div className="info__content">
                      <h3 className="info__title">Shipping Information</h3>
                      <p className="info__text">
                        Free shipping on orders over $249
                      </p>
                      <p className="info__text">Standard shipping: $25.00</p>
                      <p className="info__text">Express delivery available</p>
                    </div>
                  </div>
                </div>

                {/* 专业服务 */}
                <div className="services__section">
                  <h3 className="services__title">Our Services</h3>
                  <div className="services__grid">
                    <div className="service__item">
                      <h4 className="service__name">Technical Support</h4>
                      <p className="service__desc">
                        Expert assistance with automotive repair procedures
                      </p>
                    </div>
                    <div className="service__item">
                      <h4 className="service__name">Custom Publications</h4>
                      <p className="service__desc">
                        Specialized manuals for specific vehicle models
                      </p>
                    </div>
                    <div className="service__item">
                      <h4 className="service__name">Bulk Orders</h4>
                      <p className="service__desc">
                        Special pricing for automotive businesses
                      </p>
                    </div>
                    <div className="service__item">
                      <h4 className="service__name">Digital Downloads</h4>
                      <p className="service__desc">
                        Instant access to electronic versions
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 联系表单 */}
              <div className="contact__form-section">
                <h2 className="section__title">Send Us A Message</h2>
                <p className="form__description">
                  Have a question about our publications or need technical
                  assistance? Fill out the form below and our team will get back
                  to you promptly.
                </p>

                <form className="contact__form" onSubmit={handleSubmit}>
                  <div className="form__row">
                    <div className="form__group">
                      <label htmlFor="name" className="form__label">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="form__input"
                        required
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="form__group">
                      <label htmlFor="email" className="form__label">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="form__input"
                        required
                        placeholder="Enter your email address"
                      />
                    </div>
                  </div>

                  <div className="form__row">
                    <div className="form__group">
                      <label htmlFor="phone" className="form__label">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="form__input"
                        placeholder="Enter your phone number"
                      />
                    </div>

                    <div className="form__group">
                      <label htmlFor="subject" className="form__label">
                        Subject *
                      </label>
                      <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        className="form__select"
                        required
                      >
                        <option value="">Select a subject</option>
                        <option value="general">General Inquiry</option>
                        <option value="technical">Technical Support</option>
                        <option value="order">Order Status</option>
                        <option value="shipping">Shipping Information</option>
                        <option value="bulk">Bulk Order Inquiry</option>
                        <option value="custom">
                          Custom Publication Request
                        </option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form__group">
                    <label htmlFor="message" className="form__label">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      className="form__textarea"
                      rows="6"
                      required
                      placeholder="Please provide details about your inquiry..."
                    ></textarea>
                  </div>

                  <div className="form__actions">
                    <button
                      type="submit"
                      className="form__submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                    <p className="form__note">
                      * Required fields. We typically respond within 24 hours.
                    </p>
                  </div>
                </form>
              </div>
            </div>

            {/* 额外信息 */}
            <section className="contact__additional">
              <div className="additional__content">
                <h2 className="section__title">
                  Why Choose Emeline Publications?
                </h2>
                <div className="features__grid">
                  <div className="feature__item">
                    <div className="feature__icon">
                      <i className="fas fa-award"></i>
                    </div>
                    <h3 className="feature__title">40+ Years Experience</h3>
                    <p className="feature__text">
                      Trusted by automotive professionals across Australia and
                      internationally
                    </p>
                  </div>
                  <div className="feature__item">
                    <div className="feature__icon">
                      <i className="fas fa-tools"></i>
                    </div>
                    <h3 className="feature__title">Hands-On Research</h3>
                    <p className="feature__text">
                      Every manual created through actual vehicle dismantling
                      and rebuilding
                    </p>
                  </div>
                  <div className="feature__item">
                    <div className="feature__icon">
                      <i className="fas fa-shipping-fast"></i>
                    </div>
                    <h3 className="feature__title">Fast Delivery</h3>
                    <p className="feature__text">
                      Quick shipping across Australia with tracking information
                      provided
                    </p>
                  </div>
                  <div className="feature__item">
                    <div className="feature__icon">
                      <i className="fas fa-headset"></i>
                    </div>
                    <h3 className="feature__title">Expert Support</h3>
                    <p className="feature__text">
                      Technical assistance from certified automotive
                      professionals
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
